<template>
  <div class="agency-item" @click="selectFn">
    <div class="agency-name wh-form-item">
      {{ item.index + 1 }}. {{ item.name }}
      <div class="item-btns">
        <el-button icon="el-icon-setting" class="save-btn" plain size="mini" @click="drawer.show=true" />
        <el-button icon="el-icon-delete" class="save-btn" plain size="mini" @click="deleteFn" />
      </div>
    </div>
    <div class="agency-position">
      <span class="position-title">位置：</span>
      <div class="pos-xy">
        <span class="pos-x-img" />
        <span class="pos-txt">{{ item.x }}</span>
      </div>
      <div class="pos-xy">
        <span class="pos-y-img" />
        <span class="pos-txt">{{ item.y }}</span>
      </div>
    </div>
    <agency-drawer
      :drawer="drawer"
      @close="drawer.show=false"
      @sure="fixFn"
    />
  </div>
</template>

<script>
import { deepCopy } from '@/utils/tool'
import AgencyDrawer from '@/views/Setting/components/AgencyDrawer'

export default {
  name: 'AgencyItem',
  components: { AgencyDrawer },
  props: {
    initItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      item: {
        x: '',
        y: ''
      },
      drawer: {
        show: false,
        title: '编辑信息'
      }
    }
  },
  watch: {
    initItem: {
      handler(newV, oldV) {
        this.item = deepCopy(newV)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changePosFn() {
      this.$store.commit('changeCurAgency', this.item)
    },
    selectFn() {
      this.$emit('select', this.item)
    },
    fixFn(val) {
      this.item = {
        ...this.item,
        ...val
      }
      this.drawer.show = false
      this.$emit('fix', this.item)
    },
    deleteFn() {
      this.$confirm(`确定删除企业：${this.item.name}？`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('delete', this.item)
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
  .agency-item{
    cursor: pointer;
    .agency-name{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      /deep/ .el-input{
        width: 120px;
        font-size: 16px;
      }
      /deep/ .el-input__inner{
        border: none;
      }
      .item-btns{
        position: absolute;
        top: -4px;
        right: 4px;
      }
      .save-btn{
        background: transparent;
        color: #fff;
        padding: 4px 7px;
        border: none;
        font-size: 16px;
      }
    }
  }
  .agency-position{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 40px;
    font-size: 14px;
    .position-title{
      width: 60px;
      text-align: center;
      margin-right: 20px;
    }
    .pos-xy{
      width: 100px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      .pos-x-img{
        width: 30px;
        height: 30px;
        background: url("../images/pos-x.png") top left no-repeat;
        background-size: contain;
      }
      .pos-y-img{
        width: 30px;
        height: 30px;
        background: url("../images/pos-y.png") top left no-repeat;
        background-size: contain;
      }
      .pos-txt{
        margin-left: 4px;
      }
    }
  }
</style>
